import { safeJson } from "@/lib/http";
import { supabase } from "@/lib/supabase";

const BASE = process.env.REACT_APP_BACKEND_URL;

async function call(path, method = "GET", body) {
    const { data } = await supabase.auth.getSession();
    const token = data.session?.access_token;
    if (!token) throw new Error("Session expirée, reconnectez-vous.");
    const r = await fetch(`${BASE}${path}`, { method, headers: { Authorization: `Bearer ${token}`, ...(body ? { "Content-Type": "application/json" } : {}) }, body: body ? JSON.stringify(body) : undefined });
    const j = await safeJson(r);
    if (!r.ok) throw new Error(typeof j.detail === "string" ? j.detail : `Erreur ${r.status}`);
    return j;
}

export const fetchMemoParams = (id) => call(`/api/dossiers/${id}/memo-params`);
export const saveMemoParams = (id, patch) => call(`/api/dossiers/${id}/memo-params`, "PATCH", patch);
export const startMemoJob = (id, body) => call(`/api/ia/dossiers/${id}/memo-flash/jobs`, "POST", body || {});
export const fetchMemoJob = (id, jobId) => call(`/api/ia/dossiers/${id}/memo-flash/jobs/${jobId}`);
export const fetchLastMemo = (id) => call(`/api/ia/dossiers/${id}/memo-flash`);
export async function downloadMemoPdf(id) {
    const { data } = await supabase.auth.getSession();
    const token = data.session?.access_token;
    if (!token) throw new Error("Session expirée, reconnectez-vous.");
    const r = await fetch(`${BASE}/api/ia/dossiers/${id}/memo-flash/pdf`, { headers: { Authorization: `Bearer ${token}` } });
    if (!r.ok) { const j = await safeJson(r); throw new Error(typeof j.detail === "string" ? j.detail : `Erreur ${r.status}`); }
    const blob = await r.blob();
    const name = (r.headers.get("Content-Disposition") || "").match(/filename="([^"]+)"/)?.[1] || "Memo_Flash.pdf";
    const url = URL.createObjectURL(blob);
    const a = Object.assign(document.createElement("a"), { href: url, download: name });
    a.click();
    URL.revokeObjectURL(url);
}
export const warmupLive = (id) => call(`/api/ia/dossiers/${id}/live/warmup`, "POST");
export const askLive = (id, question) => call(`/api/ia/dossiers/${id}/live`, "POST", { question });
export const savePortailContexte = (token, email, contexte_audit, contexte_autre) =>
    fetch(`${BASE}/api/portail/${token}/contexte`, { method: "PUT", headers: { "Content-Type": "application/json" }, body: JSON.stringify({ email, contexte_audit, contexte_autre }) }).then(async (r) => { const j = await safeJson(r); if (!r.ok) throw new Error(j.detail || "Erreur"); return j; });
export const extractSalariesAdmin = (dossierId, instruction) => call("/api/ia/extract-salaries", "POST", { dossier_id: dossierId, instruction });
export const magicFillResultat = async (dossierId) => {
    const { job_id } = await call("/api/ia/magic-fill/resultat", "POST", { dossier_id: dossierId });
    for (let i = 0; i < 72; i++) {
        await new Promise((r) => setTimeout(r, 2500));
        const j = await call(`/api/ia/magic-fill/jobs/${job_id}?dossier_id=${encodeURIComponent(dossierId)}`);
        if (j.stage === "done") return j.result || {};
        if (j.stage === "error") throw new Error(j.error || "Extraction en erreur (serveur).");
    }
    throw new Error("Délai dépassé : l'extraction n'a pas répondu à temps.");
};

export const magicFillAdmin = async (dossierId, section, instruction, documentIds, onProgress) => {
    const { job_id } = await call("/api/ia/magic-fill/jobs", "POST", { dossier_id: dossierId, section_cible: section, instructions_user: instruction, document_ids: documentIds || [] });
    for (let i = 0; i < 72; i++) {  // ~180 s max, sinon on remonte un timeout explicite
        await new Promise((r) => setTimeout(r, 2500));
        const j = await call(`/api/ia/magic-fill/jobs/${job_id}?dossier_id=${encodeURIComponent(dossierId)}`);
        if (onProgress && typeof j.total_documents === "number") onProgress(j.documents_processed || 0, j.total_documents || 0);
        if (j.stage === "done") return j.result || { lignes: [] };
        if (j.stage === "error") throw new Error(j.error || "Extraction en erreur (serveur).");
    }
    throw new Error("Délai dépassé : l'extraction n'a pas répondu à temps (timeout ~3 min).");
};
